import PlacingOrderButtons from '@components/PlacingOrderButtons';
import PlacingOrderHeader from '@components/PlacingOrderHeader';
import { Grid } from '@components/Grid';
import { IPlacingOrderActionProps } from '../types';

const PlacingOrderAction: React.FC<IPlacingOrderActionProps> = (props: IPlacingOrderActionProps): React.ReactElement => {
  const { buttons, description, title } = props;

  return (
      <Grid>
        <PlacingOrderHeader
            description={description}
            title={title}
        />
        <PlacingOrderButtons buttons={buttons}/>
      </Grid>
  );
};

export default PlacingOrderAction;